<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

$(document).ready(function() {

  function countChars(text) {
    return text.trim().length;
  }

  function truncateHtmlByChars(html, maxChars, trailingHtml) {
    var container = document.createElement('div');
    container.innerHTML = html;
    var charCount = 0;
    var done = false;
    var cutTextNode = null;

    function walk(node) {
      if (done) return;
      if (node.nodeType === 3) {
        var text = node.nodeValue;
        var remaining = maxChars - charCount;

        if (text.length <= remaining) {
          charCount += text.length;
          return;
        }

        var cutAt = remaining;
        // snap naar eerstvolgende spatie, mits die niet te ver weg ligt
        var nextSpace = text.indexOf(' ', cutAt);
        if (nextSpace !== -1 && nextSpace - cutAt < 20) {
          cutAt = nextSpace;
        }

        node.nodeValue = text.slice(0, cutAt) + '…';
        cutTextNode = node;
        done = true;
        return;
      } else if (node.nodeType === 1) {
        var children = Array.prototype.slice.call(node.childNodes);
        for (var i = 0; i < children.length; i++) {
          walk(children[i]);
          if (done) {
            for (var j = children.length - 1; j > i; j--) {
              node.removeChild(children[j]);
            }
            return;
          }
        }
      }
    }

    walk(container);

    if (trailingHtml) {
      var wrapper = document.createElement('span');
      wrapper.innerHTML = ' ' + trailingHtml;
      var frag = document.createDocumentFragment();
      while (wrapper.firstChild) {
        frag.appendChild(wrapper.firstChild);
      }
      if (cutTextNode && cutTextNode.parentNode) {
        cutTextNode.parentNode.appendChild(frag);
      } else {
        container.appendChild(frag);
      }
    }

    return container.innerHTML;
  }

  var MAX_CHARS = 200; // pas aan naar wens

  $('.readMore').each(function() {
    var $el = $(this);

    var $firstHeading = $el.find('h1, h2, h3, h4, h5, h6').first();
    var headingHtml = $firstHeading.length ? $firstHeading[0].outerHTML : '';

    var $clone = $el.clone();
    if (headingHtml) {
      $clone.find('h1, h2, h3, h4, h5, h6').first().remove();
    }
    var fullHtml = $clone.html().trim();
    var fullText = $clone.text().trim();

    $el.data('heading-html', headingHtml);
    $el.data('full-html', fullHtml);

    if (countChars(fullText) > MAX_CHARS) {
      var shortHtml = truncateHtmlByChars(fullHtml, MAX_CHARS, '<a href="#" class="read-more-link"><strong>Lees verder...</strong></a>');
      $el.html(headingHtml + ' ' + shortHtml);
    } else if (headingHtml) {
      $el.html(headingHtml + ' ' + fullHtml);
    }
  });

  $(document).on('click', '.read-more-link', function(e) {
    e.preventDefault();
    var $el = $(this).closest('.readMore');
    var headingHtml = $el.data('heading-html') || '';
    var fullHtml = $el.data('full-html');
    $el.html(headingHtml + ' ' + fullHtml + ' <a href="#" class="read-less-link"><strong>Toon minder</strong></a>');
  });

  $(document).on('click', '.read-less-link', function(e) {
    e.preventDefault();
    var $el = $(this).closest('.readMore');
    var headingHtml = $el.data('heading-html') || '';
    var fullHtml = $el.data('full-html');
    var shortHtml = truncateHtmlByChars(fullHtml, MAX_CHARS, '<a href="#" class="read-more-link"><strong>Lees verder...</strong></a>');
    $el.html(headingHtml + ' ' + shortHtml);
  });
});